import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import ProgressFullscreen from './ProgressFullscreen';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(4),
    height: 'calc(100% - 64px)'
  },
  paper: {
    margin: '0 auto',
    minWidth: 800,
    maxWidth: 1980,
    height: '100%'
  }
}));

const PaperContainer = ({ children, showProgress = false }) => {
  const classes = useStyles();

  if (showProgress) {
    return <ProgressFullscreen />;
  }
  return (
    <div className={classes.container}>
      <Paper className={classes.paper}>{children}</Paper>
    </div>
  );
};

export default PaperContainer;
